import React from 'react'

export function PauseSolidRoundedIcon() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path d="M9.5 0C4.53741 0 0.5 4.03741 0.5 9C0.5 13.9626 4.53741 18 9.5 18C14.4626 18 18.5 13.9626 18.5 9C18.5 4.03741 14.4626 0 9.5 0ZM8.13636 12.2727C8.13636 12.7246 7.77003 13.0909 7.31817 13.0909C6.8663 13.0909 6.49998 12.7246 6.49998 12.2727V5.72727C6.49998 5.27541 6.8663 4.90908 7.31817 4.90908C7.77003 4.90908 8.13636 5.27541 8.13636 5.72727V12.2727ZM12.5 12.2727C12.5 12.7246 12.1337 13.0909 11.6818 13.0909C11.2299 13.0909 10.8636 12.7246 10.8636 12.2727V5.72727C10.8636 5.27541 11.2299 4.90908 11.6818 4.90908C12.1337 4.90908 12.5 5.27541 12.5 5.72727V12.2727Z" fill="#007BFF"/>
    </svg>
  )
}